export const DEVICE_ID_STORAGE_KEY = 'ims_device_id';

function generateDeviceId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  return null;
}

export function detectBrowser(userAgent = '') {
  const ua = String(userAgent);

  if (/Edg\//.test(ua)) {
    return 'Edge';
  }
  if (/OPR\//.test(ua) || /Opera/.test(ua)) {
    return 'Opera';
  }
  if (/Firefox\//.test(ua)) {
    return 'Firefox';
  }
  if (/Chrome\//.test(ua) && !/Edg\//.test(ua)) {
    return 'Chrome';
  }
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) {
    return 'Safari';
  }

  return null;
}

export function detectPlatform(userAgent = '') {
  const ua = String(userAgent);

  if (/Windows NT 10/.test(ua)) {
    return 'Windows';
  }
  if (/Windows NT/.test(ua)) {
    return 'Windows';
  }
  if (/Mac OS X/.test(ua)) {
    return 'macOS';
  }
  if (/Android/.test(ua)) {
    return 'Android';
  }
  if (/iPhone|iPad|iPod/.test(ua)) {
    return 'iOS';
  }
  if (/Linux/.test(ua)) {
    return 'Linux';
  }

  return null;
}

export function resolveDeviceName(userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  const browser = detectBrowser(userAgent);
  const platform = detectPlatform(userAgent);

  if (browser && platform) {
    return `${browser} on ${platform}`;
  }

  if (browser) {
    return browser;
  }

  if (platform) {
    return platform;
  }

  return 'Unknown browser';
}

export function getOrCreateDeviceId() {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const deviceId = generateDeviceId();
    if (deviceId) {
      localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    }

    return deviceId;
  } catch {
    return null;
  }
}

export function getLoginDeviceInfo() {
  const deviceId = getOrCreateDeviceId();

  return {
    device_id: deviceId,
    device_name: resolveDeviceName(),
  };
}
